export default __webpack_public_path__ + "static/bhyasis-da73499cf5c2ae594007a17f00e0bd03.png";